var _style, _circle, _circle2, _circle3, _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _circle4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotmapped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 126 87",
    style: {
      enableBackground: "new 0 0 126 87"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#728287;}\r\n\t.st1{fill:#3B3438;}\r\n\t.st2{fill:#00B7E9;}\r\n\t.st3{fill:none;}\r\n\t.st4{fill:#4E94EC;}\r\n\t.st5{fill:#1A75E8;stroke:#1A75E8;stroke-width:0.2615;}\r\n\t.st6{fill:url(#SVGID_1_);}\r\n\t.st7{fill:#2CF818;}\r\n\t.st8{fill:#FFFFFF;}\r\n\t.st9{fill:#5EBC53;}\r\n\t.st10{fill:#32A626;}\r\n\t.st11{fill:#666264;}\r\n\t.st12{fill:url(#SVGID_2_);}\r\n\t.st13{fill:url(#SVGID_3_);}\r\n\t.st14{fill:#EE6767;}\r\n\t.st15{fill:#FFABBF;}\r\n\t.st16{opacity:0.8;fill:#FFABBF;enable-background:new    ;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.6,
    cy: 60.2,
    r: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.6,
    cy: 66,
    r: 2.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.6,
    cy: 71.7,
    r: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,0.1H122c2.2,0,3.9,1.8,3.9,3.9v70.3c0,2.2-1.8,3.9-3.9,3.9H8.8c-2.2,0-3.9-1.8-3.9-3.9V4 C4.8,1.8,6.6,0.1,8.8,0.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.3,
    y: 74.9,
    className: "st2",
    width: 44.2,
    height: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 3,
    className: "st3",
    width: 114.3,
    height: 70.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 3,
    className: "st4",
    width: 114.3,
    height: 70.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.5,3.1C93.4,37.8,34.2,64.3,8.2,73.2h114.3V3.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M44.8,78.3h40.4l4.1,5.5H41.7L44.8,78.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,83.8c0-1.4,1.2-2.6,2.6-2.6h88.1c1.4,0,2.6,1.2,2.6,2.6v3.1H18.7V83.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -571.554,
    cy: 554.542,
    r: 0.4442,
    gradientTransform: "matrix(2.299795e-15 37.5585 37.5585 -2.299795e-15 -20763.0078 21503.9297)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C95454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE6767"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 64.8,
    cy: 37.2,
    r: 16.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M57.8,57c-0.6,0.2-1.4,0.4-1.8,0.8c-0.6,0.6-0.8,1.4-0.9,2.3c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c-0.1-0.7-0.3-1.5-0.7-2c-0.5-0.6-1.3-0.9-2-1.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0.7-0.2,1.4-0.4,1.9-0.9c0.5-0.5,0.7-1.4,0.9-2.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.2,0.7,0.4,1.6,0.9,2.1 c0.5,0.6,1.2,0.8,1.9,1c0,0,0,0,0,0C57.8,56.9,57.8,56.9,57.8,57C57.8,56.9,57.8,56.9,57.8,57C57.8,57,57.8,57,57.8,57z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.3,21.8c-0.9,0.2-1.9,0.5-2.6,1.2c-0.8,0.8-1.1,2-1.3,3.2c0,0,0,0,0,0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0 c0,0,0,0,0-0.1c-0.2-1-0.5-2.1-1-2.9c-0.7-0.9-1.8-1.3-2.9-1.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1s0,0,0.1,0 c0.9-0.2,2-0.6,2.7-1.3c0.7-0.8,1-2,1.2-3.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0.2,1.1,0.6,2.3,1.2,3 c0.7,0.8,1.7,1.2,2.7,1.4c0,0,0,0,0.1,0c0,0,0,0,0,0.1C87.4,21.7,87.4,21.7,87.3,21.8C87.3,21.7,87.3,21.8,87.3,21.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M93.7,36.3c-0.9,0.2-1.9,0.5-2.6,1.2c-0.8,0.8-1.1,2-1.3,3.2c0,0,0,0,0,0.1c0,0,0,0-0.1,0s0,0-0.1,0 c0,0,0,0,0-0.1c-0.2-1-0.5-2.1-1-2.9c-0.7-0.9-1.8-1.3-2.9-1.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0 c0.9-0.2,2-0.6,2.7-1.3c0.7-0.8,1-2,1.2-3.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0s0,0,0.1,0c0,0,0,0,0,0.1c0.2,1.1,0.6,2.3,1.2,3 c0.7,0.8,1.7,1.2,2.7,1.4c0,0,0,0,0.1,0c0,0,0,0,0,0.1C93.7,36.2,93.7,36.3,93.7,36.3C93.7,36.3,93.7,36.3,93.7,36.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M56.2,14.8c-0.7,0.2-1.5,0.4-2,0.9c-0.6,0.6-0.8,1.5-1,2.4c0,0,0,0,0,0c0,0,0,0-0.1,0s0,0-0.1,0c0,0,0,0,0,0 c-0.2-0.7-0.4-1.6-0.8-2.2c-0.5-0.7-1.4-1-2.2-1.2c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0.7-0.2,1.5-0.4,2.1-1 c0.5-0.6,0.8-1.5,0.9-2.4c0,0,0,0,0,0c0,0,0,0,0.1,0s0,0,0.1,0c0,0,0,0,0,0c0.2,0.8,0.5,1.7,0.9,2.3c0.5,0.6,1.3,0.9,2,1.1 c0,0,0,0,0,0C56.3,14.7,56.3,14.7,56.2,14.8C56.3,14.8,56.3,14.8,56.2,14.8C56.3,14.8,56.2,14.8,56.2,14.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M44,36.3c-0.9,0.2-1.9,0.5-2.6,1.2c-0.8,0.8-1.1,2-1.3,3.2c0,0,0,0,0,0.1c0,0,0,0-0.1,0s0,0-0.1,0 c0,0,0,0,0-0.1c-0.2-1-0.5-2.1-1-2.9c-0.7-0.9-1.8-1.3-2.9-1.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0 c0.9-0.2,2-0.6,2.7-1.3c0.7-0.8,1-2,1.2-3.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0s0,0,0.1,0c0,0,0,0,0,0.1c0.2,1.1,0.6,2.3,1.2,3 c0.7,0.8,1.7,1.2,2.7,1.4c0,0,0,0,0.1,0c0,0,0,0,0,0.1C44.1,36.2,44,36.3,44,36.3C44,36.3,44,36.3,44,36.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M42.7,26.7c-0.3,0.1-0.7,0.2-0.9,0.4c-0.3,0.3-0.4,0.7-0.5,1.1c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0 c-0.1-0.3-0.2-0.7-0.4-1c-0.2-0.3-0.6-0.4-1-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.3-0.1,0.7-0.2,0.9-0.4 c0.2-0.3,0.3-0.7,0.4-1.1c0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0c0.1,0.4,0.2,0.8,0.4,1C42,26.4,42.3,26.6,42.7,26.7 C42.7,26.7,42.7,26.7,42.7,26.7C42.7,26.7,42.7,26.7,42.7,26.7C42.7,26.7,42.7,26.7,42.7,26.7C42.7,26.7,42.7,26.7,42.7,26.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M86.9,50.7c-0.3,0.1-0.7,0.2-0.9,0.4c-0.3,0.3-0.4,0.7-0.5,1.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c-0.1-0.3-0.2-0.7-0.4-1c-0.2-0.3-0.6-0.4-1-0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0.3-0.1,0.7-0.2,0.9-0.4c0.2-0.3,0.3-0.7,0.4-1.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.4,0.2,0.8,0.4,1 C86.2,50.4,86.5,50.5,86.9,50.7C86.9,50.6,86.9,50.6,86.9,50.7C86.9,50.6,86.9,50.6,86.9,50.7C86.9,50.6,86.9,50.6,86.9,50.7 C86.9,50.7,86.9,50.7,86.9,50.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.8,55.1c-9.6,0-17.5-7.8-17.5-17.5c0-9.6,7.8-17.5,17.5-17.5c9.6,0,17.5,7.8,17.5,17.5 C82.2,47.3,74.4,55.1,64.8,55.1z M64.8,21.4c-9,0-16.3,7.3-16.3,16.3c0,9,7.3,16.3,16.3,16.3c9,0,16.3-7.3,16.3-16.3 C81.1,28.7,73.8,21.4,64.8,21.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M69.7,22.3c-3.8-1.6-14.3-2-19.7,8.4C55.1,24.6,60.5,21.6,69.7,22.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M61.3,53.6c8.9-0.6,15-5.8,19.3-12.1c-0.7,3.9-3.3,7.5-6.5,9.7C70.8,53.4,65.8,54.7,61.3,53.6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68.7,29.7l-3.9,4.4l-4.2-3.7c-2.4-2.1-5.9,1.5-3.4,3.6c1.5,1.3,2.9,2.6,4.4,3.9l-3.7,4.3 c-2.1,2.4,1.5,5.9,3.6,3.4l3.9-4.4l4.3,3.7c2.4,2.1,5.9-1.5,3.4-3.6l-4.4-3.9l3.7-4.3C74.4,30.8,70.8,27.3,68.7,29.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotmapped);
export default __webpack_public_path__ + "static/media/notmapped.fcd12b9a428d4b70746188f27566d847.svg";
export { ForwardRef as ReactComponent };